import React from 'react'
import { connect } from 'react-redux'
import { Button, Typography, ButtonGroup, Grid, Card, CardContent, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

import { addToCart, removeFromCart } from '../../actions/userAction'


const useStyles = makeStyles((theme) => ({
    card: props => ({
        marginBottom: props.noSpace ? '0' : '10px',
        borderRadius: props.noSpace ? '0' : '20px',
        border: props.noSpace ? '0' : 'auto'
    }),
    cardContent: props => ({
        padding: props.noSpace ? '5px' : 'auto'
    })
}));


const CartItem = (props) => {

    const classes = useStyles(props)

    const { config, cartLoading } = props
    return (
        <Card variant="outlined" className={classes.card} id={config.configId}>
            <CardContent className={classes.cardContent}>
                <Grid container >
                    <Grid item xs={7}>
                        <Typography aria-label={config.title} component="p" variant="body1" align="left" color="primary" style={{ textTransform: 'capitalize' }}>
                            {config.title.toLowerCase()}
                        </Typography>

                        {
                            Object.keys(config.customization).length > 0 &&
                            <><strong style={{ fontSize: "12px", color: "#56595a", padding: "0px" }}>{Object.keys(config.customization).length} ADD ON :</strong> <br></br> </>
                        }
                        {

                            Object.keys(config.customization).map((key, index) => {
                                const addon = config.customization[key]
                                const len = Object.keys(config.customization).length
                                return <span style={{ color: "#56595a", fontSize: "12px" }} key={addon.id}>{addon.name}
                                    {index <= len - 2 && <span> | </span>}
                                </span>
                            })
                        }

                        <Typography aria-label={config.price} component="p" variant="body1" align="left" color="primary">
                            <strong> ₹ {parseInt(config.totalPrice) * parseInt(config.quantity)}</strong>
                        </Typography>

                        <Typography aria-label={config.price} component="p" variant="caption" align="left" color="textSecondary">
                            ( {config.totalPrice} * {config.quantity} )
                        </Typography>

                    </Grid>
                    <Grid item xs={5} align="right" >

                        <ButtonGroup color="secondary" fullWidth size="small" variant="contained" aria-label="outlined primary button group">
                            <Button onClick={
                                () => {
                                    props.removeFromCart({ itemId: config.id, configId: config.configId })
                                }
                            }>
                                -
                        </Button>
                            <Button>{cartLoading ? <CircularProgress size={12} color="primary" /> : config.quantity}</Button>
                            <Button onClick={() => { props.addToCart(config) }} >+</Button>
                        </ButtonGroup>
                    </Grid >
                </Grid>
            </CardContent>
        </Card>
    )

}



export default connect(null, { addToCart, removeFromCart })(CartItem)